import { createAction } from '@reduxjs/toolkit';

import { CampaignConfig, SET_CAMPAIGN_CONFIG } from './types';

export const setCampaignConfig = createAction<CampaignConfig | null, typeof SET_CAMPAIGN_CONFIG>(
	SET_CAMPAIGN_CONFIG,
);
